import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { ServerRequestProtected, ServerRequestProtectedWithoutToken } from './ServerDataRequest';
import { enumUtil } from './Enum';
import NotificationHandler from './NotificationHandler';

const  JoinTelehealth = () => {

    const [searchParams] = useSearchParams();
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
      const API_URL = enumUtil.controller.Patient;

    useEffect(() => {

        const appointmentId = searchParams.get('appointmentId');
        const userType = searchParams.get("userType");
        
        // // ✅ CORRECT ALERTS
        // alert(`appointmentId from URL: ${appointmentId}`);
        // alert(`Full URL: ${window.location.href}`);
        
        console.log('appointmentId from URL:', appointmentId);
        console.log('Full URL:', window.location.href);

        if (!appointmentId) {
            // alert('No appointment ID found!');
            setError('Invalid appointment link - No appointment ID found');
            return;
        }

        setIsLoading(true);

        // alert(`Calling API with appointmentId: ${appointmentId}`);

 ServerRequestProtectedWithoutToken(API_URL + "/JoinTeleHealth", 'post',{
                "value": appointmentId,
                "TableName": "PatientAppointment",
                "SearchParam":userType,
            }
        ).then((response) => {

            console.log('API Response:', response);
            // alert(`API Response received: ${JSON.stringify(response)}`);
            
            setIsLoading(false);

           const url = response?.redirectUrl || response?.RedirectUrl;

    if (url) {
        window.location.href = url;
    } else {
        setError('Doxy URL not found');
    }

        }).catch((error) => {

            console.error('API Error:', error);
            console.error('Error response:', error?.response);
            
            // alert(`API Error: ${error.message}`);
              if (error?.response?.data === 'No data found') {
                    NotificationHandler(
                      'Invalid Date and Time ',
                      enumUtil.enumtoaster.error
                    );
                  }

                  else {
 setIsLoading(false);
            setError('Failed to join telehealth session: ' + (error?.response?.data?.message || error.message));
            NotificationHandler(
                error?.response?.data,
                enumUtil.enumtoaster.error
            );
                  }
           
        });

    }, [searchParams]);

    return (
        <div style={{ 
            padding: '40px', 
            textAlign: 'center',
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#f0f0f0'  // ✅ Background add kiya to visible ho
        }}>

            <h2 style={{ marginBottom: '20px', color: 'blue' }}>
                Joining Telehealth Session...
            </h2>

            <p style={{ marginBottom: '20px', color: '#666' }}>
                Please wait while we connect you to your appointment.
            </p>
            
            <p style={{ fontSize: '14px', color: 'green' }}>
                Appointment ID: {searchParams.get('appointmentId') || 'Not found'}
            </p>

            {isLoading && (
                <div style={{ 
                    fontSize: '18px', 
                    color: '#007bff',
                    marginTop: '20px',
                    fontWeight: 'bold'
                }}>
                    Loading... Please wait
                </div>
            )}

            {error && (
                <div style={{ 
                    color: 'red', 
                    marginTop: '20px',
                    padding: '15px',
                    border: '2px solid red',
                    borderRadius: '5px',
                    backgroundColor: '#ffe6e6',
                    fontWeight: 'bold'
                }}>
                    {error}
                </div>
            )}
        </div>
    );
}

export default JoinTelehealth;


// const JoinTelehealth=()=> {
//     alert('Component loaded!');
//     let Url='http://localhost:3000/JoinTelehealth'
    
//     return (
//         <div style={{ 
//             padding: '100px',
//             backgroundColor: 'yellow',
//             fontSize: '30px',
//             textAlign: 'center'
//         }}>
//             <h1>🎉 COMPONENT LOADED SUCCESSFULLY! 🎉</h1>
//             <p>URL: {window.location.href}</p>
//         </div>
//     );
// // }

// export default JoinTelehealth;